import { useState } from 'react'

/**
 * Previous/next over opaque server cursors (P-REC-001). Keeps the stack of cursors seen so
 * far; any change of `resetKey` (the filters) starts again from the first page.
 */
export function useCursorPager(resetKey: string) {
  const [state, setState] = useState<{ key: string; stack: string[] }>({
    key: resetKey,
    stack: [],
  })
  const stack = state.key === resetKey ? state.stack : []

  return {
    cursor: stack[stack.length - 1],
    page: stack.length + 1,
    hasPrevious: stack.length > 0,
    next: (nextCursor: string | null | undefined) => {
      if (nextCursor) setState({ key: resetKey, stack: [...stack, nextCursor] })
    },
    previous: () => setState({ key: resetKey, stack: stack.slice(0, -1) }),
  }
}
